import * as React from 'react';
import { captionSelectStyles } from './FiltersWeekRangePicker.styles';

interface YearMonthDropdownsProps {
  date: Date;
  localeUtils: any;
  onChange: (month: Date) => void;
  fromYear: number;
  toYear: number;
}

/** lets users jump to any month/year instead of clicking month by month */
function YearMonthDropdowns({ date, localeUtils, onChange, fromYear, toYear }: YearMonthDropdownsProps) {
  const months: string[] = localeUtils.getMonths();

  const years: number[] = [];
  for (let i = fromYear; i <= toYear; i++) years.push(i);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { year, month } = e.target.form as any;
    onChange(new Date(year.value, month.value));
  };

  return (
    <form className="DayPicker-Caption">
      <select name="month" onChange={handleChange} value={date.getMonth()} className={captionSelectStyles}>
        {months.map((month, i) => (
          <option key={month} value={i}>
            {month}
          </option>
        ))}
      </select>
      <select name="year" onChange={handleChange} value={date.getFullYear()} className={captionSelectStyles}>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </form>
  );
}

export default YearMonthDropdowns;
